"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6831,5323],{

/***/ 5323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ InfoArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _styles_jss_bbhost_components_infoStyle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69747);



// nodejs library to set properties for components

// nodejs library that concatenates classes

// @material-ui/core components


var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_styles_jss_bbhost_components_infoStyle_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
function InfoArea(props) {
    var classes = useStyles();
    var title = props.title, description = props.description, iconColor = props.iconColor, vertical = props.vertical, style = props.style;
    var _obj;
    var iconWrapper = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, classes.iconWrapper, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, classes[iconColor], true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, classes.iconWrapperVertical, vertical), _obj));
    var _obj1;
    var iconClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, classes.icon, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, classes.iconVertical, vertical), _obj1));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.infoArea,
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: iconWrapper,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(props.icon, {
                    className: iconClasses
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.descriptionWrapper,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        className: classes.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: classes.title,
                        children: description
                    })
                ]
            })
        ]
    });
}
InfoArea.defaultProps = {
    iconColor: "gray"
};
InfoArea.propTypes = {
    icon: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object.isRequired),
    title: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node)
    ]),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    iconColor: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOf([
        "primary",
        "warning",
        "danger",
        "success",
        "info",
        "rose",
        "gray", 
    ]),
    vertical: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool)
};


/***/ }),

/***/ 69747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21086);

var infoStyle = {
    infoArea: {
        maxWidth: "360px",
        margin: "0 auto",
        padding: "0px"
    },
    iconWrapper: {
        float: "left",
        marginTop: "24px",
        marginRight: "10px"
    },
    primary: {
        color: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .primaryColor */ .lr
    },
    warning: {
        color: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .warningColor */ .MA
    },
    danger: {
        color: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .dangerColor */ .E7
    },
    success: {
        color: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .successColor */ .nq
    },
    info: {
        color: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .infoColor */ .bE
    },
    rose: {
        color: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .roseColor */ .An
    },
    gray: {
        color: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .grayColor */ .X_
    },
    icon: {
        width: "36px",
        height: "36px"
    },
    descriptionWrapper: {
        color: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .grayColor */ .X_,
        overflow: "hidden"
    },
    title: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .title */ .TN,
    description: {
        color: "#212121",
        overflow: "hidden",
        marginTop: "0px",
        fontSize: "14px"
    },
    iconWrapperVertical: {
        float: "none"
    },
    iconVertical: {
        width: "61px",
        height: "61px"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (infoStyle);


/***/ })

}]);